import { mix } from 'mixwith/mixwith';
import { AssetLocationMetaMixin } from '/@/modules/asset/models/mixins/AssetLocationMetaMixin';
import { AssetOwnershipMeta } from '/@/modules/asset/models/meta/AssetOwnershipMeta';
import { AssetLocation } from '/@/modules/asset/enums/AssetLocation';
import Lang from '/@/modules/core/app/services/Lang';

export class OtherAssetMeta extends mix(AssetOwnershipMeta).with(AssetLocationMetaMixin) {
  sharePercentage;

  constructor(model = {}) {
    super(model);
    this.initLocation(model);
    this.sharePercentage = model.sharePercentage;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return this.location
      ? AssetLocation.getByKey(this.location).value
      : Lang.t('asset.other-type-of');
  }
}
